import { FormationEdit } from "./FormationEdit";
import { FormationList } from "./FormationList";

export default {
  list: FormationList,
  edit: FormationEdit,
  recordRepresentation: "titre",
};
